import type { ReleasesFilters } from "@services/releases/list/type";
import { formatDateTimeForAPI } from "@utils/formatters";
import { defaultFilters } from "@typings/entities/releases/filter";
import { useFilters } from "@hooks/useFilters";

export function useReleasesFilters(defaults: ReleasesFilters = defaultFilters) {
  return useFilters<ReleasesFilters>({
    defaults,
    transform: (filters) => ({
      ...filters,
      startDate: formatDateTimeForAPI(filters.startDate ?? ""),
      endDate: formatDateTimeForAPI(filters.endDate ?? ""),
    }),
  });
}
